import { Pipe, PipeTransform } from '@angular/core';

import { TranslatorService } from '@services/translator/translator.service';
/**
 * Pipe that translates some values using NGX translate tool.
 *
 * This class should not be modified.
 */
@Pipe({
  name: 'translatorPipe'
})
export class TranslatorPipe implements PipeTransform {
  constructor(
    private translateService: TranslatorService) {
  }
  /**
   * Translates the provided value
   * @param value
   * @param enumerationName
   * @param args
   */
   transform(value: any, enumerationName?: any, args?: any): any {
    if(typeof value === "boolean") {
      value = value.toString();
    }
    let returnedValue = value;
    if (enumerationName)  {
      returnedValue= this.translateService.translateEnumItem(value,enumerationName);
    } else if (args) {
      this.translateService
    .getMessage(value,args).subscribe(data=> {
      returnedValue=data;
    });
  } else {
       this.translateService
    .getMessage(value).subscribe(data=> {
      returnedValue=data;
    });
    }
      return returnedValue;
  }


}
